var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"home"},[_c('menuTemplate',{attrs:{"screens":_vm.screens,"menu":_vm.menu,"playerInstance":_vm.playerInstance,"screenId":'home'}}),_c('router-view',{attrs:{"playerInstance":_vm.playerInstance}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }